import React, { useState } from 'react'
import './Search.scss';
import { ISearchProps } from '../../interfaces/ISearchProps';

export default function Search({setKeyword}: ISearchProps) {

    const [searchInput, setSearchInput] = useState<string>('');

    const updateInput = (text: string) => {
        setSearchInput(text);
        setKeyword(text);
    }

    return (
        <form className="search-form" onSubmit={(e) => e.preventDefault()}>
            <svg className="search-icon" viewBox="0 0 24 24" fill="none" strokeWidth={2} strokeLinecap="round">
                <circle cx="11" cy="11" r="7"/>
                <path d="m20 20-3-3"/>
            </svg>
            <input
                className="search-input"
                key="random1"
                value={searchInput}
                placeholder={"Search scripts…"}
                onChange={(e) => updateInput(e.target.value)}
            />
        </form>
    )
}
